'use strict'

import { axiosPost } from '../../../../../axios/axios.js'

export function mapObjectsListProperties (object, objectSrc, objectInitial, properties) {
  mapProperties(object, objectSrc, objectInitial, properties, getObjectsIds, equalArrays)
}
export function getObjectsIds (objects) {
  return objects && objects.length ? objects.map(o => typeof o === 'object' ? o.id : o) : []
}
function mapBooleanProperties (object, objectSrc, objectInitial, properties) {
  mapProperties(object, objectSrc, objectInitial, properties, getBooleanValue)
}
function getBooleanValue (value) {
  return !!value
}
export function mapProperties (object, objectSrc, objectInitial, properties, mapFn, equalFn) {
  if (objectSrc == null) {
    objectSrc = object
  }
  if (!equalFn) {
    equalFn = equalCommon
  }
  properties.forEach(property => {
    const propertyTo = typeof property === 'string' ? property : property.to
    const propertyFrom = typeof property === 'string' ? property : property.from
    const valueSrc = objectSrc[propertyFrom]
    if (valueSrc !== undefined) {
      const value = mapFn(valueSrc)
      if (objectInitial) {
        const valueSrcInitial = objectInitial[propertyFrom]
        if (valueSrcInitial !== undefined && equalFn(value, mapFn(valueSrcInitial))) {
          return
        }
      }
      object[propertyTo] = value
      console.log('Changed: ' + propertyTo + ': ' + JSON.stringify(value))
    }
  })
}
function equalCommon (v1, v2) {
  return v1 === v2 // TODO
}
function equalArrays (v1, v2) {
  if (v1 === v2) {
    return true
  } else if (v1 == null && v2 == null) {
    return true
  } else if (v1 == null || v2 == null) {
    return false
  }
  return Array.isArray(v1) && Array.isArray(v2) && v1.length === v2.length && v1.every((val, index) => val === v2[index])
}

export const brigadeEditor = {
  data: function () {
    const brigadeCommonAutoAssignListProperties = [
      'autoAssignRequestTypes',
      'autoAssignExcludeRequestTypes',
      'autoAssignAllWorkTypes',
      'autoAssignAllWorkPackages',
      'autoAssignAnyWorkTypes',
      'autoAssignAnyWorkTypeFromAnyWorkPackages',
      'autoAssignAnyWorkTypeFromAllWorkPackages',
      'autoAssignAnyWorkPackages',
      'autoAssignExcludeWorkTypes',
      'autoAssignExcludeWorkPackages'
    ]

    const brigadeUrgentAutoAssignListProperties = [
      'autoAssignAsUrgentRequestTypes',
      'autoAssignAsUrgentExcludeRequestTypes',
      'autoAssignAsUrgentAllWorkTypes',
      'autoAssignAsUrgentAllWorkPackages',
      'autoAssignAsUrgentAnyWorkTypes',
      'autoAssignAsUrgentAnyWorkTypeFromAnyWorkPackages',
      'autoAssignAsUrgentAnyWorkTypeFromAllWorkPackages',
      'autoAssignAsUrgentAnyWorkPackages',
      'autoAssignAsUrgentExcludeWorkTypes',
      'autoAssignAsUrgentExcludeWorkPackages'
    ]

    return {
      brigadeBooleanProperties: [
        'autoForm',
        'autoRequestAssign',
        'autoAssignAllObjectRequests',
        'autoRequestAssignAsUrgent',
        'accessibleToOtherWorkAreas',
        'worksCheckRequired',
        'strictQueueOrderExecution',
        'withoutDeparture',
        'withoutVehicle',
        'setWithoutVehicleForever',
        'monitoringReportDisabled',
        'setMonitoringReportDisabledForever',
        'autoAssignOnlyWithForkliftTruck',
        'ignoreVehicleReturnToStockAfterWorkShift',
        'allowWaybillWithoutOrderAdmittance',
        'stockControlSkipAllowed',
        'canSkipMaintenanceNote'
      ],
      brigadeCommonAutoAssignListProperties: brigadeCommonAutoAssignListProperties,
      brigadeUrgentAutoAssignListProperties: brigadeUrgentAutoAssignListProperties,
      brigadeAutoAssignListProperties: [
        ...brigadeCommonAutoAssignListProperties,
        ...brigadeUrgentAutoAssignListProperties
      ]
    }
  },
  methods: {
    pushBrigadeBooleanPropertiesToSave: function (object, objectSrc, objectInitial, properties) {
      mapBooleanProperties(object, objectSrc, objectInitial, properties != null ? properties : this.brigadeBooleanProperties)
    },
    pushBrigadeListPropertiesToSave: function (object, objectSrc, objectInitial, properties) {
      mapObjectsListProperties(object, objectSrc, objectInitial, properties != null ? properties : this.brigadeAutoAssignListProperties)
    },
    copyListProperties: function (object, objectSrc, properties) {
      properties.forEach(property => {
        this.$set(object, property, JSON.parse(JSON.stringify(objectSrc[property] || [])))
      })
    },
    copyBooleanProperties: function (object, objectSrc, properties) {
      properties.forEach(property => {
        this.$set(object, property, !!objectSrc[property])
      })
    },
    onChangeSuccess: function (response) {
      response.data.result.forEach(brigadeChangeResult => {
        if (brigadeChangeResult.property === 'forkliftTruck' && brigadeChangeResult.hasReportsToUpdate) {
          const forkliftTruck = brigadeChangeResult.forkliftTruckOld
          if (forkliftTruck) {
            this.$d_ask({
              callback: (data, action) => {
                if (action === 'yes') {
                  this.removeForkliftTruckFromActiveReports(brigadeChangeResult)
                }
              },
              header: `Удалить автовышку «${forkliftTruck.name}» из активных отчётов бригады «${brigadeChangeResult.name}»?`,
              buttons: {
                yes: 'Да',
                cancel2: 'Нет'
              }
            })
          }
        }
      })
      return response
    },
    removeForkliftTruckFromActiveReports: function (brigadeChangeResult) {
      const forkliftTruck = brigadeChangeResult.forkliftTruckOld

      const bodyFormData = new FormData()
      bodyFormData.set('id', brigadeChangeResult.id)
      bodyFormData.set('forkliftTruckId', forkliftTruck.id)

      axiosPost({
        url: '/service/delta/brigade/removeForkliftTruckFromActiveReports',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: `Успешная отвязка вышки «${forkliftTruck.name}» от активных отчётов бригады «${brigadeChangeResult.name}»`,
            progress: true,
            timeout: 5000
          })
        },
        onFailure: `Ошибка отвязки вышки «${forkliftTruck.name}» от активных отчётов бригады «${brigadeChangeResult.name}»`,
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
